// extracted by mini-css-extract-plugin
export default {"navbar":"Xh8NA","navbar-list":"jAzil","menu-item":"_1G1J7","menu-item-placeholder":"q6m1e"};